
// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginRedirectGuard } from './core/guards/login-redirect.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import(
        './pages/invitations/accept-invitation/accept-invitation.component'
      ).then((m) => m.AcceptInvitationComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [LoginRedirectGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./pages/analytics/analytics.component').then(
            (m) => m.AnalyticsComponent
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'invitations',
        loadComponent: () =>
          import('./pages/invitations/invitations.component').then(
            (m) => m.InvitationsComponent
          ),
      },
      {
        path: 'sessions',
        loadComponent: () =>
          import('./pages/sessions/sessions.component').then(
            (m) => m.SessionsComponent
          ),
      },
      {
        path: 'audit-logs',
        loadComponent: () =>
          import('./pages/audit/audit-logs.component').then(
            (m) => m.AuditLogsComponent
          ),
      },
      {
        path: 'subscriptions',
        loadComponent: () =>
          import('./pages/subscriptions/subscriptions.component').then(
            (m) => m.SubscriptionsComponent
          ),
      },
      {
        path: 'plans',
        loadComponent: () =>
          import('./pages/plans/plans.component').then((m) => m.PlansComponent),
      },
      {
        path: 'promotions',
        loadComponent: () =>
          import('./pages/promotions/promotions.component').then((m) => m.PromotionsComponent),
      },
      {
        path: 'user-messages',
        loadComponent: () =>
          import('./pages/user-messages/user-messages.component').then((m) => m.UserMessagesComponent),
      },
      {
        path: 'alerts',
        loadComponent: () =>
          import('./pages/alerts/alerts.component').then((m) => m.AlertsComponent),
      },
      {
        path: 'crons',
        loadComponent: () =>
          import('./pages/crons/crons.component').then((m) => m.CronsComponent),
      },
      {
        path: 'legal-content',
        loadComponent: () =>
          import('./pages/legal-content/legal-content.component').then((m) => m.LegalContentComponent),
      },
      {
        path: 'libraries',
        loadComponent: () =>
          import('./pages/libraries/libraries.component').then((m) => m.LibrariesComponent),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },

  // fallback
  { path: '**', redirectTo: 'login' },
];

